/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Failed_To_Submit_FeedbackInputs */

const en_toast_failed_to_submit_feedback = /** @type {(inputs: Toast_Failed_To_Submit_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit feedback`)
};

const nl_toast_failed_to_submit_feedback = /** @type {(inputs: Toast_Failed_To_Submit_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versturen van feedback mislukt`)
};

/**
* | output |
* | --- |
* | "Failed to submit feedback" |
*
* @param {Toast_Failed_To_Submit_FeedbackInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_failed_to_submit_feedback = /** @type {((inputs?: Toast_Failed_To_Submit_FeedbackInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Failed_To_Submit_FeedbackInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_failed_to_submit_feedback(inputs)
	return en_toast_failed_to_submit_feedback(inputs)
});